import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CharacterSelector from '../components/CharacterLists/CharacterSelector';
import ApplicationIFrame from '../components/ApplicationFrame';
import LoadingScreen from '../components/@common/LoadingScreen/LoadingScreen';
import { translate } from '../translations/translator';
import { remCalc } from '../util/style-util';
import { white } from '../styles/style-constants';
import { Locale, CharacterTypeSectionState, Resource, Workbook } from 'types';
import { selectCharacter, fetchCharacters } from 'state/modules/app';
import { createEvent } from 'api';
import withModal from '@lwtears/lwt-common-frontend/lib/Modal/withModal';
import { UseModalDispatch, UseModalState } from '@lwtears/lwt-common-frontend/lib/Modal';
import withStyles from 'components/@layout/withStyles';
import { RouterProps } from 'react-router';
const translateApps = key => translate('apps', key);

type Props = {
  charactersApp: string;
  items: CharacterTypeSectionState[];
  locale: Locale;
  selectedCharacter: Resource;
  showLoadingScreen: boolean;
  currentWorkbook: Workbook;
  selectCharacter: (character: Resource) => void;
  toggleSlideoutMenu: (boolean) => void;
  fetchCharacters: (applicationId: string) => Array<Resource>;
  classes?: any;
} & RouterProps &
  UseModalDispatch &
  UseModalState;

class WoodPieces extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchCharacters('woodPieces');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locale !== this.props.locale) {
      prevProps.fetchCharacters('woodPieces');
    }
  }

  handleClickItem = async (character: Resource) => {
    await this.props.selectCharacter(character);
    this.openModal();

    createEvent('accessResource', {
      section: 'woodPieces',
      resourceId: character.id,
      resourceType: character.type.type
    });
  };

  openModal = (): void => {
    const { selectedCharacter } = this.props;
    const {
      title,
      url,
      data: { aspectRatio, heightAdjust }
    } = selectedCharacter;

    this.props.openDraggableModal({
      body: <ApplicationIFrame aspectRatio={aspectRatio} heightAdjust={heightAdjust} url={url} />,
      titleText: title
    });
  };

  render() {
    const {
      charactersApp,
      items,
      locale,
      showLoadingScreen,
      currentWorkbook,
      classes: { container, content, note }
    } = this.props;
    return (
      <div className={container}>
        <LoadingScreen loading={showLoadingScreen} />
        <div className={content}>
          <CharacterSelector
            items={charactersApp === 'woodPieces' ? items : []}
            onClickItem={this.handleClickItem}
            application={'WoodPieces'}
            locale={locale}
            currentWorkbook={currentWorkbook}
          />
          <div className={note}>{translateApps('woodPiecesNote')}</div>
        </div>
      </div>
    );
  }
}

const styles: any = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: white
  },
  content: {
    flex: 1,
    width: '100%',
    padding: remCalc(20),
    overflowY: 'auto'
  },
  checkBoxContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%'
  },
  note: {
    float: 'right',
    right: remCalc(50),
    bottom: remCalc(100)
  }
};

const mapStateToProps = (state: any) => ({
  charactersApp: state.app.app,
  items: state.entity.characterswoodPieces,
  locale: state.app.locale,
  selectedCharacter: state.app.character.selectedCharacter,
  showLoadingScreen: state.app.showLoadingScreen,
  currentWorkbook: state.app.currentWorkbook
});

export default compose(
  withModal,
  withStyles(styles),
  connect<any>(mapStateToProps, {
    selectCharacter,
    fetchCharacters
  })
)(WoodPieces);
